const { ref, reactive } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.permService = exports.resetPwd = exports.signUp = exports.getSmsCode = exports.clearUserToken = exports.getUserInfo = exports.logout = exports.refreshToken = exports.login = exports.userToken = void 0;
const tslib_1 = require("tslib");
const project_1 = require("@/service/project");
const model_1 = require("@/model");
const one_message_1 = require("@/utils/one_message");
const router_1 = tslib_1.__importDefault(require("@/router"));
const api_1 = tslib_1.__importDefault(require("@/api"));
const work_1 = require("@/store/modules/work");
const laborer_1 = require("@/store/modules/laborer");
const core_1 = require("@vueuse/core");
exports.userToken = {
    username: (0, core_1.useLocalStorage)("username", ""),
    token: (0, core_1.useLocalStorage)("token", ""),
    refreshToken: (0, core_1.useLocalStorage)("refreshToken", ""),
    expire: (0, core_1.useLocalStorage)("expire", ""),
    refreshExpire: (0, core_1.useLocalStorage)("refreshExpire", ""),
    lastRefresh: (0, core_1.useLocalStorage)("lastRefresh", ""),
    loginTime: (0, core_1.useLocalStorage)("loginTime", ""),
    data: ref(null)
};
let userInfo = reactive({});
const login = (username, password) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let loginTime = Date.now().toString();
    let lastRefreshTime = loginTime;
    const res = yield (0, api_1.default)('login', {
        username,
        password
    });
    if (!((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.token))
        throw new Error(res.message);
    exports.userToken.username.value = username;
    exports.userToken.loginTime.value = loginTime;
    exports.userToken.lastRefresh.value = lastRefreshTime;
    exports.userToken.token.value = res.data.token;
    exports.userToken.expire.value = String(res.data.expire * 1000);
    exports.userToken.refreshExpire.value = String(res.data.refreshExpire * 1000);
    exports.userToken.refreshToken.value = res.data.refreshToken;
    return res;
});
exports.login = login;
const refreshToken = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    let refreshTime = Date.now().toString();
    const res = yield (0, api_1.default)('refreshToken', {
        refreshToken: exports.userToken.refreshToken.value
    });
    if (!(res === null || res === void 0 ? void 0 : res.data))
        throw new Error(`登陆失败!【${res.code}】`);
    exports.userToken.lastRefresh.value = refreshTime;
    exports.userToken.token.value = res.data.token;
    exports.userToken.expire.value = String(res.data.expire * 1000);
    exports.userToken.refreshExpire.value = String(res.data.refreshExpire * 1000);
    exports.userToken.refreshToken.value = res.data.refreshToken;
    return res.data.token;
});
exports.refreshToken = refreshToken;
const logout = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    let workStore = (0, work_1.useWork)();
    let laborerStore = (0, laborer_1.useLaborer)();
    const handleLogout = (clearCache = true) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        let res = yield (0, api_1.default)('logout');
        if (res.code == 1000) {
            project_1.ProjectService.current().closeAutoSave();
            if (clearCache) {
                model_1.Project.clearProjectCache();
            }
            project_1.ProjectService.current().clearCache();
            (0, exports.clearUserToken)();
            (0, one_message_1.oneMessage)({ message: "退出成功", type: 'success' });
            yield router_1.default.push('/');
            workStore.resetProject();
            laborerStore.resetState();
        }
        else {
            (0, one_message_1.oneMessage)({ message: res.message, type: 'error' });
        }
    });
    if (workStore.projectSaveState === '' || workStore.projectSaveState === 'saved') {
        yield handleLogout();
        return;
    }
    let saveRes = yield model_1.Project.current().saveProject();
    if (saveRes.code == 200 || saveRes.code == 1000) {
        yield handleLogout();
    }
    else {
        yield handleLogout(false);
    }
});
exports.logout = logout;
const getUserInfo = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    if (Object.keys(userInfo).length !== 0)
        return userInfo;
    const res = yield (0, api_1.default)('user.info');
    if (res.code === 1000)
        userInfo = res.data;
    else
        userInfo = {};
    return userInfo;
});
exports.getUserInfo = getUserInfo;
const clearUserToken = () => {
    exports.userToken.username.value = "";
    exports.userToken.token.value = "";
    exports.userToken.expire.value = "";
    exports.userToken.refreshExpire.value = "";
    exports.userToken.lastRefresh.value = "";
    exports.userToken.refreshToken.value = "";
    exports.userToken.loginTime.value = "";
    userInfo = {};
};
exports.clearUserToken = clearUserToken;
const getSmsCode = (phone) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    return yield (0, api_1.default)('sms', { phone });
});
exports.getSmsCode = getSmsCode;
const signUp = (params) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    return yield (0, api_1.default)('signup', params);
});
exports.signUp = signUp;
const resetPwd = (params) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    return yield (0, api_1.default)('resetPwd', params);
});
exports.resetPwd = resetPwd;
exports.permService = {
    hasPerm: (perm) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        let userInfo = yield (0, exports.getUserInfo)();
        if (!userInfo || !userInfo.perms || userInfo.perms.length === 0) {
            return false;
        }
        let perms = userInfo.perms;
        return perms.includes(`app:ide:page:${perm}`);
    }),
    hasDesign: () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        return yield exports.permService.hasPerm('design');
    }),
    hasProgram: () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        return yield exports.permService.hasPerm('program');
    }),
    hasLaborer: () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        return yield exports.permService.hasPerm('laborer');
    })
};
